import { render, staticRenderFns } from "./VideoPlayerControl.vue?vue&type=template&id=5b61a85a&scoped=true"
import script from "./VideoPlayerControl.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControl.vue?vue&type=script&lang=js"
import "./VideoPlayerControl.vue?vue&type=style&index=0&id=5b61a85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61a85a",
  null
  
)

export default component.exports